import EntityChallengeDelete from './EntityChallengeDelete';

export default EntityChallengeDelete;
